import { useLayoutEffect, useRef } from 'react';
import { focusNonFocusableElement } from '../../lib/DomUtils/utils';

export function useFocusOnRefresh<T extends HTMLElement>(refreshCounter: number) {
  const elementToFocus = useRef<T>(null);
  useLayoutEffect(() => {
    if (refreshCounter > 0 && elementToFocus.current !== null) {
      elementToFocus.current.focus();
    }
  }, [refreshCounter]);

  return elementToFocus;
}

export function useFocusOnRefreshWithTabIndex<T extends HTMLElement>(refreshCounter: number) {
  const elementToFocus = useRef<T>(null);
  useLayoutEffect(() => {
    if (refreshCounter > 0 && elementToFocus.current !== null) {
      focusNonFocusableElement(elementToFocus.current);
    }
  }, [refreshCounter]);

  return elementToFocus;
}
